import BlastTab from './components/UI/BlastTab';
import BlastTabs from './components/UI/BlastTabs';
import BlastRadio from './components/UI/BlastRadio';
import BlastSelect from './components/UI/BlastSelect';
import BlastSwitch from './components/UI/BlastSwitch';
import BlastCollapse from './components/UI/BlastCollapse';
import BlastTextArea from './components/UI/BlastTextArea';
import BlastCheckbox from './components/UI/BlastCheckbox';
import BlastTextInput from './components/UI/BlastTextInput';
import BlastHighlight from './components/UI/BlastHighlight';
import BlastSimpleTabs from './components/UI/BlastSimpleTabs';
import BlastFileManager from './components/UI/BlastFileManager';

const BlastUI = {
    install(Vue, options) {
        Vue.component(BlastTab.name, BlastTab);
        Vue.component(BlastTabs.name, BlastTabs);
        Vue.component(BlastRadio.name, BlastRadio);
        Vue.component(BlastSelect.name, BlastSelect);
        Vue.component(BlastSwitch.name, BlastSwitch);
        Vue.component(BlastCollapse.name, BlastCollapse);
        Vue.component(BlastTextArea.name, BlastTextArea);
        Vue.component(BlastCheckbox.name, BlastCheckbox);
        Vue.component(BlastTextInput.name, BlastTextInput);
        Vue.component(BlastHighlight.name, BlastHighlight);
        Vue.component(BlastSimpleTabs.name, BlastSimpleTabs);
        Vue.component(BlastFileManager.name, BlastFileManager);
    }
};

export default BlastUI;